import React from "react";
import CountryImg from "../../../../assets/country.png";
import Away from "../../../../assets/teams/away.JPG";
import { BsBell } from "react-icons/bs";

const LastMatches = () => {
  return (
    <>
      <div className="team-tab-header">
        <img src={Away} width="40" />
      </div>

      <div>
        <div className="score-box-header p-2 mt-5 flex justify-between">
          <div>
            <img src={CountryImg} style={{display: "inline", marginRight: 10}} />
            <p style={{display: "inline"}}>England - Premier League</p>
          </div>
          <div>
        
          </div>
        </div>
        <div className="p-2 mt-5 score-box-content grid">
          <div>
            <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
            <p className="font-bold inline">Live</p>
          </div>
          <div>
            <p className="font-bold">35`</p>
          </div>
          <div>
            <p className="block font-bold">Wolverhampton</p>
            <p className="block font-bold">Liverpool</p>
          </div>
          <div className="text-right">
            <p className="block font-bold">0</p>
            <p className="block font-bold">1</p>
          </div>
          <div>
            <BsBell style={{float: "right"}} />
          </div>
        </div>
      </div>
      <div>
        <div className="score-box-header p-2 mt-5 flex justify-between">
          <div>
            <img src={CountryImg} style={{display: "inline", marginRight: 10}} />
            <p style={{display: "inline"}}>England - Premier League</p>
          </div>
          <div>
        
          </div>
        </div>
        <div className="p-2 mt-5 score-box-content grid">
          <div>
            <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
            <p className="font-bold inline">Live</p>
          </div>
          <div>
            <p className="font-bold">35`</p>
          </div>
          <div>
            <p className="block font-bold">Wolverhampton</p>
            <p className="block font-bold">Liverpool</p>
          </div>
          <div className="text-right">
            <p className="block font-bold">0</p>
            <p className="block font-bold">1</p>
          </div>
          <div>
            <BsBell style={{float: "right"}} />
          </div>
        </div>
      </div>
      <div>
        <div className="score-box-header p-2 mt-5 flex justify-between">
          <div>
            <img src={CountryImg} style={{display: "inline", marginRight: 10}} />
            <p style={{display: "inline"}}>England - Premier League</p>
          </div>
          <div>
        
          </div>
        </div>
        <div className="p-2 mt-5 score-box-content grid">
          <div>
            <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
            <p className="font-bold inline">Live</p>
          </div>
          <div>
            <p className="font-bold">35`</p>
          </div>
          <div>
            <p className="block font-bold">Wolverhampton</p>
            <p className="block font-bold">Liverpool</p>
          </div>
          <div className="text-right">
            <p className="block font-bold">0</p>
            <p className="block font-bold">1</p>
          </div>
          <div>
            <BsBell style={{float: "right"}} />
          </div>
        </div>
      </div>
    </>
  );
};



export default LastMatches;